module.exports = __webpack_public_path__ + "img/gather_bottom_ruffle.e6b9f2f6.png";